





































import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { cloneDeep } from 'lodash';


@Component
export default class BookmarkAddMenu extends Vue {
  @Prop({ default: {} })
  data;

  index: number = 0;
  item: any;
  value: boolean;
  title: string;

  bookmarkTitle: string = '';

  get editLabel() {
    return this.edit 
      ? this.t('Edit a Bookmark')
      : this.t('Add a Bookmark');
  }

  get disabled() {
    return !this.bookmarkTitle;
  }

  get edit() {
    return this.index !== -1;
  }

  get currentBookmark() {
    return this.$store.state.bookmarks[this.index] as Bemob.Bookmark;
  }

  mounted() {
    const { index = 0, item = null, title = '' } = this.data
    this.index = index;
    this.item = item;
    this.title = title;

    this.bookmarkTitle = this.edit ? this.currentBookmark?.bookmarkTitle : this.title
  }

  onClose() {
    this.$emit('close')
  }

  addBookmark(forceCreate: boolean = false) {
    if(this.disabled) {
      return;
    }

    const { state, commit } = this.$store;

    const url = this.item.tabId === this.$store.state.table.activeTab
      ? this.$route.fullPath
      : this.item.url;
    
    const bookmark: Bemob.Bookmark = {
      bookmarkTitle: this.bookmarkTitle,
      url: url,
      id: this.item.id,
      drill: this.item.drill,
      title: this.title,
      tabData: {
        tableQuery: cloneDeep({...state.table.query, date: 'customDateTime'}),
        tableQueryTemporary: cloneDeep({...state.table.queryTemporary, date: 'customDateTime'}),
      }
    };
    
    if(this.edit && !forceCreate) {
      commit('editBookmark', {
        bookmark: bookmark,
        index: this.index
      });
      
      
      this.bus.emit('toast-success', this.t('Bookmark has been edited'));
    } else {
      commit('addBookmark', bookmark);

      this.bus.emit('toast-success', this.t('Bookmark has been created'));
    }

    this.onClose()
  }

  removeBookmark() {
    this.$store.commit('removeBookmark', this.index);
    this.bus.emit('toast-success', this.t('Bookmark has been removed'));
    this.onClose()
  }
}
